import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { IonicModule } from '@ionic/angular/lazy';
import { TranslateModule } from '@ngx-translate/core';

import { OdsLoaderComponent } from '@/app/app/components/ods-loader/ods-loader.component';
import { NotificationStore } from '@/shared/lib/stores/notification.store';

@Component({
  selector: 'ods-notification-progress',
  imports: [IonicModule, OdsLoaderComponent, TranslateModule],
  templateUrl: './notification-progress.component.html',
  styleUrl: './notification-progress.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class NotificationProgressComponent {
  notificationStore = inject(NotificationStore);

  dismiss() {
    this.notificationStore.dismissLoading();
  }
}
